import React, { useState, useEffect, useRef } from "react";
import { Button } from "react-bootstrap";
import styles from "./seekChat.module.scss";
import cx from "classnames";
import _ from "lodash";
import { useDispatch, useSelector } from 'react-redux';
import Typewriter from 'typewriter-effect';
import AssetCard from '../seekAssetCard/index.jsx';
import likeFill from './feedbackIcons/likeFill.svg';
import dislikeFill from './feedbackIcons/dislikeFill.svg';
import { updateSeekHelpful, fetchEmailForSeekResponse} from "actions/seek.jsx";
import { PF_CHROME_OPEN_COMPOSE, PF_CHROME_WEBAPP_ATTACH_ASSETS, REDIRECT_URL } from "constants/actionTypes";
import CollectionWidgetManager from 'services/collections.widget.service';
import { generateAnonymousLinksRequest } from 'actions/links';
import { selectAsset } from 'actions/selection';
import { trackAdoptionMetricsForAssetDetailViewedEvent, trackAdoptionMetricsForSearchReactedEvent } from "actions/adoption";

const webAppUrl = process.env.REACT_APP_WEBAPP_URL;

const placeholderMessages = [
  "Rummaging through the archives to unravel the mysteries of the universe...just a few more moments!",
  "Searching for answers in all documents, so you don't have to go full detective mode!",
  "Roses are red, violets are blue, searching for answers, just for you!",
  "Digging through the digital haystack, to find the needle of knowledge you seek!",
  "Putting on my detective hat and scouring the documents for clues to solve the mystery!",
];

export default function SeekChat(props) {
  const dispatch = useDispatch();
  var scrollBottomInterval = useRef(null);

  const widgetManager = new CollectionWidgetManager();
  const assets = _.size(_.get(props, 'chat.contents')) > 0 && _.get(props, 'chat.contents', []);


  const profile = useSelector((state) => _.get(state, 'users.profile.item') || null);
  const emailbody = useSelector(state => _.get(state, "seek.emailBody"));
  const applicationContext = useSelector(state => _.get(state, 'application'));
  const activeTab = useSelector((state) => _.get(state, 'application.activeTab') || null);

  const [state, setState] = useState({
    showAssets: false,
    isHelpfulHovered: false,
    isNotHelpfulHovered: false,
    filteredAssets: [],  // assets user has access to view
    answer: "",
    placeholder: false,
    isHelpful: null
  });

  const [draftingEmail, setDraftingEmail] = useState(false);
  const [shouldFetchEmail, setShouldFetchEmail] = useState(false);
  const [isPaperflite, setIsPaperflite] = useState(false);

  useEffect(() => {
    if(shouldFetchEmail && emailbody && assets){
    emailFetchTrigger()
    setShouldFetchEmail(false); 
  }
  }, [emailbody])
  
  const chatAssets = _.get(props, "chat.contents", []);


  useEffect(() => {

    updateAnswer(props.chat);

    // getting assets which user can view
    const chatAssets = _.get(props, "chat.contents", []);
    const filteredAssets = chatAssets.filter((asset) => asset.canView)
    setState({
      ...state,
      filteredAssets: filteredAssets
    })
  }, []);


  useEffect(() => {
    updateAnswer(props.chat);
  }, [props.chat])

  useEffect(() => {
    const citationElements = document.querySelectorAll("#seek__id");
    
    if(citationElements) {
      citationElements.forEach((element) => {
        element.addEventListener('click', handleClick);
      });
    }
    
  }, [state.showAssets])

  useEffect(() => {
    if (activeTab && activeTab.includes("app.paperflite.com")) {
      setIsPaperflite(true);
    }
  }, [activeTab])


  const updateAnswer = (chat) => {
    var message = chat.answer;

    const seekErrors = _.get(chat, "error.errors");
    if (seekErrors) {
      const code = seekErrors[0].code;
      message = seekErrors[0].message
      if(code === 20003) {
        message = "Unfortunately, you've reached the permissible limit of questions on the SEEK"
      }
    }

    if (chat.querying) {
      var rand = Math.floor(Math.random() * _.size(placeholderMessages));
      message = placeholderMessages[rand];
      setState({
        ...state,
        placeholder: true,
        placeholderMessage: message
      })
    } else {
      if (_.size(chat.contents) > 0){
        message = `${message} <br /><br />To better understand the topic, we suggest you read the asset provided below. It will give you more information and help you learn more. <br /><br />`;
      }

      message = processAnswerForCitations(message, chat);
      
      setState({
        ...state,
        placeholder: false,
        answer: message,
      })
    }
  }

  const handleClick = (e) => {
    if(isPaperflite){
      triggerMessageToPlugin({
        type: REDIRECT_URL,
        payload: `${webAppUrl}/assets/${e.target.dataset.cite}?source=chrome_extension`,
    });
    }

    dispatch(trackAdoptionMetricsForAssetDetailViewedEvent("Asset Detail Viewed", "Seek", ""));
  }
 
  const processAnswerForCitations = (message, chat) => {
    var summaryElement = document.createElement("div");
    summaryElement.innerHTML = message;

    //Fix legacy citations
    var citationsNodes = summaryElement.querySelectorAll('a');
    Array.from(citationsNodes).forEach(citationNode => {
      var citeId = citationNode.innerText;
      citeId = citeId.replace("[", "");
      citeId = citeId.replace("]", "");
      
      const citation = chat.citations.find(item => item.id == citeId);
      if (!citation || !citation.content) {
        citationNode.remove();
      }

      const anchor = document.createElement("a");

      anchor.setAttribute("id",'seek__id');
      anchor.classList.add('seek__cite');
      anchor.setAttribute('href', `${webAppUrl}/assets/${citation.content.id}?source=chrome_extension`);
      anchor.setAttribute('target', `_blank`);
      anchor.innerHTML = citationNode.innerHTML;
      anchor.dataset.cite = citeId;
      citationNode.replaceWith(anchor);
    });

    citationsNodes = summaryElement.querySelectorAll('span.seek__cite');
    Array.from(citationsNodes).forEach(citationNode => {

      let citeId = citationNode.innerText.trim().replace(/\[|\]/g, "");
      const citation = chat.citations.find(item => item.id == citeId);
      if (!citation || !citation.content) {
        citationNode.remove();
      }

      const anchor = document.createElement("a");
      anchor.setAttribute("id",'seek__id');
      anchor.classList.add('seek__cite');

      if(!isPaperflite){
        anchor.setAttribute('href', `${webAppUrl}/assets/${citation.content.id}?source=chrome_extension`);
        anchor.setAttribute('target', `_blank`);
      }
      anchor.innerHTML = citationNode.innerHTML;
      anchor.innerText = citationNode.innerText.replace(/\[|\]/g, "");
      anchor.dataset.cite = citeId; 

      citationNode.replaceWith(anchor);
    });

    return summaryElement.innerHTML;
  }

  const convertToLineBreaks = (text) => {
    if (text) {
      return text.replace(/\n/g, '<br />');
    }
  };

  const handleAnswerType = (typewriter) => {
    props.handleEnableTyping();
    
    clearScrollBottomInterval();
    scrollBottomInterval.current = window.setInterval(() => {
      props.handleScrollWhileTyping()
    }, 100);

    typewriter
      .typeString(convertToLineBreaks(state.answer))
      .callFunction(() => {
        setState({
          ...state,
          showAssets: true
        });

        props.handleDisableTyping();
        setTimeout(() => {
          clearScrollBottomInterval();
        }, 1000);
      })
      .start()
  }

  const handlePlaceHolderType = (typewriter) => {
    props.handleEnableTyping();
    clearScrollBottomInterval();

    scrollBottomInterval.current = window.setInterval(() => {
      props.handleScrollWhileTyping();
    }, 100)
    typewriter
      .typeString(convertToLineBreaks(state.placeholderMessage))
      .callFunction(() => {
        setTimeout(() => {
          clearScrollBottomInterval();
        }, 1000);
      })
      .start()
  }

  const clearScrollBottomInterval = () => {
    if (scrollBottomInterval.current) {
      window.clearInterval(scrollBottomInterval.current);
      scrollBottomInterval.current = null;
    }
  }

  const renderAssets = () => {
    return (
      <div>
        <div className={styles.assets}>
          {_.size(props.chat.contents) > 0 && (props.chat.contents || []).map((asset) => {
            return <AssetCard key={asset.id} asset={asset} />;
          })
          }
        </div>
        {renderFeedbackActions()}
        <div className={styles.divider}> </div>
      </div>
    )
  }

  const SeekButton = ({ border , className, onClick, icon, children }) => {
    return (
      <button
        className={cx(styles.button, {
          [styles.border]: border,
        }, className)}
        onClick={onClick}
      >
        {icon && <i className={cx(styles.icon, icon)}></i>}
        {children}
      </button>
    );
  };

  const triggerMessageToPlugin = (message) => {
    window.parent.postMessage(message, "*");
  }

  const emailFetchTrigger = async() =>{
    const filteredAssets = _.filter(assets, (asset) => _.get(asset, "settings.share",false));
    filteredAssets.forEach(asset => {
      dispatch(selectAsset(asset));
    });

      var entities = [];
      if (filteredAssets.length > 0) {
        entities = [...filteredAssets];
      }

      const request = {
        type: "anonymous",
        ...(applicationContext.settings || {}),
      };
    
    
    const generateLinks = (entities, request) => {
      return new Promise((resolve, reject) => {
        dispatch(generateAnonymousLinksRequest(entities, request, (response) => {
          var combinedHtml = emailbody;
          if(response.collection || _.size(response.assets) > 0){
            const html = widgetManager.widget(response.widget).render(response);
            combinedHtml = emailbody + html;
          }
          const context = {
            ...response,
            html: combinedHtml
          };
  
          triggerMessageToPlugin({
            type: PF_CHROME_OPEN_COMPOSE,
            payload: context,
          });
          setTimeout(() => {
            triggerMessageToPlugin({
              type: PF_CHROME_WEBAPP_ATTACH_ASSETS,
              payload: context,
            });
          }, 1000);
  
          setDraftingEmail(false);
          resolve();
        }, (error) => {
          console.error("Request failed:", error);
          setDraftingEmail(false);
          reject(error);
        }));
      });
    };
  
    try {
      await generateLinks(entities, request);
    } catch (error) {
      console.error("An error occurred during content attachment:", error);
    }
  }
  
  const handleAttachContent = async () => {
    setDraftingEmail(true);
    try {
      dispatch(fetchEmailForSeekResponse(props.chat.id, props.chat.session))
      setShouldFetchEmail(true);
    } catch (error) {
      console.error(error);
    }
  };
  
  const renderFeedbackActions = () => {
    return (
      <div className={cx(styles.feedback, {
        [styles.noAssets]: _.size(props.chat.contents) === 0
      })}>
        {assets && _.get(props, "attachAssets") &&
        <Button
        className={cx(styles.draftIcon,{
          [styles.disableButton]: draftingEmail
        })} onClick={!draftingEmail && handleAttachContent} >
          <i className={cx("paperflite-send")}></i>
        </Button>}

        <Button
          className={cx(styles.thumb, styles.up)} onClick={() => handleLike(true)}>
          {(state.isHelpful || state.isHelpfulHovered) ?
            <img alt="Thumbs Up Icon" src={likeFill} /> : <i className="paperflite-thumbs-up-unslected" />}
        </Button>
        <Button
          className={cx(styles.thumb, styles.down)} onClick={() => handleLike(false)}>
          {(state.isHelpful === false || state.isNotHelpfulHovered) ?
            <img alt="Thumbs Down Icon" src={dislikeFill} /> : <i className="paperflite-thumbs-down-unselected" />}
        </Button>
      </div>
    );
  }

  const handleLike = (isHelpful) => {
    if (isHelpful !== state.isHelpful) {
      setState({
        ...state,
        isHelpful: isHelpful
      });
      dispatch(updateSeekHelpful(props.chat.id, isHelpful));
      const reactionType = isHelpful ? "Like" : "Dislike";
      dispatch(trackAdoptionMetricsForSearchReactedEvent("Search Reacted", reactionType));
    }
  }

  return (
    <div className={styles.chat}>
      <div className={styles.question}>
        <p>{props.chat.question}</p>
      </div>
      <div className={styles.answerWrapper}>
        <div className={styles.answerTitle}>Response</div>
        <div className={styles.answerDivider}></div>
      </div>
      <div className={styles.answer}>
        {!state.placeholder &&
        <div className={styles.wrapper}>
          <Typewriter
            key={0}
            options={{
              strings: [''],
              autoStart: false,
              loop: false,
              delay: 0,
              cursor: ""
            }}
            onInit={handleAnswerType}
          />
          {state.showAssets &&
            renderAssets()
          }
        </div>}
        {state.placeholder &&
          <Typewriter
            key={1}
            options={{
              strings: [''],
              autoStart: false,
              loop: false,
              delay: 0,
              cursor: ""
            }}
            onInit={handlePlaceHolderType}
          />
        }
      </div>
    </div>
  );
}